import settings from '~/settings';

export const isChinese = () => settings.realm.languageCode === 'zh-cn';

export const isChinaRealm = () => settings.realm.code === 'cn360';
